import type { AppBuild } from './version';

// Baked in by vite.config.ts from APP_VERSION / APP_COMMIT / APP_BUILT_AT (Dockerfile build args).
declare const __APP_BUILD__: AppBuild | undefined;

/** The build this page was loaded from. */
export const thisBuild: AppBuild =
  typeof __APP_BUILD__ === 'undefined' ? { version: null, commit: null, builtAt: null } : __APP_BUILD__;
